import React from 'react';

import PendencyModal from 'design-system/PendencyModal';

import { PENDENCIAS_TEXTS } from '../constants';
import { CompensationDetail, CompensationList } from './styles';

type CompensationModalProps = {
  open: boolean;
  onClose: () => void;
};

const CompensationModal = ({
  open,
  onClose,
}: CompensationModalProps): JSX.Element => (
  <PendencyModal
    open={open}
    title={PENDENCIAS_TEXTS.MODAL_COMPENSATION_TITLE}
    onClose={onClose}
    width={660}
  >
    <CompensationList>
      <li>
        {PENDENCIAS_TEXTS.MODAL_COMPENSATION_PIX_LABEL}
        <strong>{PENDENCIAS_TEXTS.MODAL_COMPENSATION_PIX_VALUE}</strong>
      </li>
      <li>
        {PENDENCIAS_TEXTS.MODAL_COMPENSATION_SLIP_LABEL}
        <CompensationDetail>
          {PENDENCIAS_TEXTS.MODAL_COMPENSATION_SLIP_WEEKDAYS}
        </CompensationDetail>
        <CompensationDetail>
          {PENDENCIAS_TEXTS.MODAL_COMPENSATION_SLIP_WEEKEND}
        </CompensationDetail>
      </li>
    </CompensationList>
  </PendencyModal>
);

export default CompensationModal;
